import { render, staticRenderFns } from "./SysCategoryDictList.vue?vue&type=template&id=7ae93767&scoped=true&"
import script from "./SysCategoryDictList.vue?vue&type=script&lang=js&"
export * from "./SysCategoryDictList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae93767",
  null
  
)

export default component.exports